import React from 'react';
import { Input } from 'antd';

const { Search } = Input;

class ReasonInput extends React.Component{
    render() {

        return (
            <Search 
                enterButton="Submit" 
                onSearch={this.handleSubmit} 
                placeholder="Submit a reason for downloading the emails"  />
        )
    }

    handleSubmit = ( value ) => {
        this.props.onSubmit({
            reason: value,
            emailType: this.props.emailType
        })
    }
}

export default ReasonInput;


// WEBPACK FOOTER //
// ./src/components/email/input.js